module.exports = __webpack_public_path__ + "img/9788932917689.9e342de5.jpg";